module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box__selected"
  }, [_c('div', [_c('div', {
    staticClass: "box-title box-title__theme"
  }, [_vm._v("\n      " + _vm._s(_vm.getElementLabel()) + "\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "box-back",
    on: {
      "click": function($event) {
        return _vm.sidebarChangePanel('style')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" " + _vm._s(_vm.$t('general.actions.back')) + "\n    ")])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7e9b0b01!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/modifiers/Header.vue
 ** module id = 878
 ** module chunks = 1
 **/